{
  "es": {
    "validation": {
      "emailAddressDemo": "La dirección de correo de un contacto en esta cuenta de demostración debe terminar en '{email_address_suffix}' o '{'@'}ziggu.io'",
      "emailTaken": "Esta dirección de correo ya está en uso",
      "errorsInLanguages": "Algunas traducciones tienen errores, revisa: {languages}",
      "import": {
        "inclusion": "Error en la línea {rowNumber}, columna {columnNumber}: {headerName} no está incluido en la lista",
        "inclusion_values": "con los valores permitidos: {values}",
        "invalid": "Error en la línea {rowNumber}, columna {columnNumber}: {headerName} no es válido",
        "required": "Error en la línea {rowNumber}, columna {columnNumber}: se requiere un valor para {headerName}",
        "unique": "Error en la línea {rowNumber}: {headerName} no es único, hay otra fila con este valor"
      },
      "nameAlreadyTaken": "Este nombre ya está en uso",
      "needCompany": "La organización es obligatoria",
      "needName": "El nombre es obligatorio"
    }
  }
}
